import * as React from 'react';
import styles from './auth.scss';

export const Dialog = ({children}) => (
  <div className={`container d-flex flex-column justify-content-around ${styles.baseView}`}>
    {children}
  </div>);
